import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import PhaseForm from '~/components/etaiement/form/PhaseForm';
import { useGetEtaiement } from '~/hooks/etaiements';

import styles from './phase.module.scss';
import { IPhase } from '~/types/estimates';

const Phase = ({ isPreview }: { isPreview: boolean }) => {
  const { id, phaseId } = useParams();

  const {
    data: etaiement,
  } = useGetEtaiement(id || '');

  const phase = useMemo(() => {
    const found = etaiement?.phases.find((d: IPhase) => d._id === phaseId);
    return found;
  }, [etaiement, phaseId]);

  return (
    <div className={styles.phase}>
      <div className={styles.content}>
        {(id && phase) && (
          <PhaseForm
            key={`phase-${phase._id}`}
            etaiementId={id}
            phase={phase}
            isPreview={isPreview}
          />
        )}
      </div>
    </div>

  );
};

export default Phase;
